const defaultWildCards: string[] = ['transparent']

export const getColorValue = (color: string, wildcards: string[] = defaultWildCards): string => {
  if (wildcards.includes(color)) {
    return color
  }
  if (color.startsWith('#') || color.startsWith('rgb')) return color
  return `#${color}`
}
